

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '博物馆',
      width: 100,
    },
    {
      key: 'project',
      dataIndex: 'project',
      title: '评估得分',
      width: 100,
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '评估成绩',
    },
    {
      key: 'add',
      dataIndex: 'add',
      title: '排名',
    }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
